export const SvgCollapse = ({ collapsed = false, size = 24, ...rest }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.369 6.542a4.81 4.81 0 014.173-4.173C8.052 2.169 9.942 2 12 2c2.059 0 3.948.17 5.458.369a4.81 4.81 0 014.173 4.173c.2 1.51.369 3.4.369 5.458 0 2.059-.17 3.948-.369 5.458a4.81 4.81 0 01-4.173 4.173c-1.51.2-3.4.369-5.458.369-2.059 0-3.948-.17-5.458-.369a4.81 4.81 0 01-4.173-4.173C2.169 15.948 2 14.058 2 12c0-2.059.17-3.948.369-5.458z"
        fill="#C6DDF7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          collapsed
            ? "M9.793 7.793a1 1 0 000 1.414L12.586 12l-2.793 2.793a1 1 0 101.414 1.414l3.5-3.5a1 1 0 000-1.414l-3.5-3.5a1 1 0 00-1.414 0z"
            : "M14.207 7.793a1 1 0 010 1.414L11.414 12l2.793 2.793a1 1 0 01-1.414 1.414l-3.5-3.5a1 1 0 010-1.414l3.5-3.5a1 1 0 011.414 0z"
        }
        fill="#4834D4"
      />
    </svg>
  );
};
export const SvgDownload = ({ color = "#fff", size = 16, ...rest }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9224 11.4227L10.5891 14.756C10.2637 15.0814 9.73602 15.0814 9.41058 14.756L6.07725 11.4227C5.75181 11.0972 5.75181 10.5696 6.07725 10.2442C6.40269 9.91872 6.93032 9.91872 7.25576 10.2442L9.1665 12.1549V2.50008C9.1665 2.03984 9.5396 1.66675 9.99984 1.66675C10.4601 1.66675 10.8332 2.03984 10.8332 2.50008V12.1549L12.7439 10.2442C13.0694 9.91872 13.597 9.91872 13.9224 10.2442C14.2479 10.5696 14.2479 11.0972 13.9224 11.4227Z"
        fill="white"
      />
      <path
        d="M3.33317 14.5834C3.33317 14.1232 2.96007 13.7501 2.49984 13.7501C2.0396 13.7501 1.6665 14.1232 1.6665 14.5834V15.8334C1.6665 17.6744 3.15889 19.1667 4.99984 19.1667H14.9998C16.8408 19.1667 18.3332 17.6744 18.3332 15.8334V14.5834C18.3332 14.1232 17.9601 13.7501 17.4998 13.7501C17.0396 13.7501 16.6665 14.1232 16.6665 14.5834V15.8334C16.6665 16.7539 15.9203 17.5001 14.9998 17.5001H4.99984C4.07936 17.5001 3.33317 16.7539 3.33317 15.8334V14.5834Z"
        fill="white"
      />
    </svg>
  );
};
export const SvgNaira = ({ color = "#fff", size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...rest}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.278 4.167a.833.833 0 0 0-1.667 0v3.571H9.494L7.012 4.016c-.686-1.029-2.29-.543-2.29.693v3.029H3.333a.833.833 0 0 0 0 1.667h1.39v1.19h-1.39a.833.833 0 0 0 0 1.667h1.39v3.571a.833.833 0 0 0 1.666 0v-3.571h4.118l2.48 3.722c.687 1.029 2.291.543 2.291-.694v-3.028h1.389a.833.833 0 0 0 0-1.667h-1.389v-1.19h1.389a.833.833 0 0 0 0-1.667h-1.389zm-3.88 6.428-.793-1.19h3.006v1.19zm2.213 3.32-1.101-1.653h1.101zm-5.01-4.51.794 1.19H6.39v-1.19zM6.39 6.085l1.102 1.653H6.389z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SvgTransactions = ({ collapsed = false, size = 24, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M10 4.41 4.36 6.667l1.843.737.004.002L10 8.923l3.794-1.517.004-.002 1.843-.737-5.64-2.257ZM2.456 8.06l.685.273-.685.274c-1.257.503-1.257 2.283 0 2.786l.685.274-.685.274c-1.257.502-1.257 2.282 0 2.785l6.987 2.795a1.5 1.5 0 0 0 1.114 0l6.987-2.795c1.258-.503 1.258-2.283 0-2.785l-.684-.274.684-.274c1.258-.503 1.258-2.283 0-2.786l-.684-.274.684-.274c1.258-.503 1.258-2.282 0-2.785l-6.987-2.795a1.5 1.5 0 0 0-1.114 0L2.456 5.274c-1.257.503-1.257 2.282 0 2.785Zm11.338 2.679.003-.001L15.64 10l-1.474-.59-3.61 1.444a1.5 1.5 0 0 1-1.114 0L5.833 9.41 4.36 10l1.845.738h.002L10 12.257l3.794-1.517Zm-7.96 2.005 3.61 1.444a1.5 1.5 0 0 0 1.113 0l3.61-1.444 1.474.59-5.64 2.256-5.642-2.257 1.475-.59Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const SvgInflow = ({ color = "#fff", size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...rest}
    >
      <path
        fill="#fff"
        d="m17.911 12.298.227.202h.195v-1.667h-1.666a.833.833 0 0 0-.833.868 2.5 2.5 0 0 1 2.077.597"
      />
      <path
        fill="#fff"
        d="M5.834 16.667h7.087a2.5 2.5 0 0 1 .418-3.258l.983-.873a2.5 2.5 0 0 1 2.345-3.369h1.666v-.37a2.5 2.5 0 0 0-2.499-2.5h-2.917l-.01-.005H5.835a.833.833 0 0 1 0-1.667h6.053c-.317-.675-.645-1.292-1.042-1.292H5.187c-1.023 0-1.854.83-1.854 1.854v8.98a2.5 2.5 0 0 0 2.5 2.5"
      />
      <path
        fill="#fff"
        d="M16.804 13.544a.833.833 0 0 0-1.107 0l-1.25 1.11a.833.833 0 0 0 .97 1.346v2.333a.833.833 0 0 0 1.667 0V16a.834.834 0 0 0 .97-1.345z"
      />
    </svg>
  );
};
export const SvgOutflow = ({ color = "#fff", size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...rest}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M1.667 5.532A3.03 3.03 0 0 1 4.699 2.5h6.656c.329 0 .596.13.785.263.188.131.346.297.474.452.254.309.49.7.69 1.045l.145.25c.154.267.29.505.427.71q.102.154.175.243h.95a3.333 3.333 0 0 1 3.332 3.333v3.988a2.5 2.5 0 0 0-1.666-1.083v-.868H15a.833.833 0 0 0-.472 1.52 2.5 2.5 0 0 0-.758 1.491A2.5 2.5 0 0 1 15 9.167h1.666v-.37c0-.921-.745-1.667-1.666-1.667H3.333v7.037c0 .92.746 1.666 1.667 1.666h7.921a2.5 2.5 0 0 0-.406 1.667H5a3.333 3.333 0 0 1-3.333-3.333zm1.668-.069h8.74l-.087-.15-.124-.215c-.205-.35-.38-.632-.536-.823a1 1 0 0 0-.1-.108h-6.53c-.73 0-1.327.574-1.363 1.296"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m18.054 17.845-1.25 1.111a.833.833 0 0 1-1.108 0l-1.25-1.11a.833.833 0 0 1 .97-1.346v-2.333a.833.833 0 1 1 1.667 0V16.5a.834.834 0 0 1 .97 1.345"
      />
    </svg>
  );
};

export const SvgLogo = ({ color = "#2F80ED", size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={146}
      height={36}
      fill="none"
      {...rest}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m10.376 26.148.035.029c.888.734 11.65 9.627 12.02 9.823H12.89c-1.399 0-2.534-1.166-2.53-2.604zM10.834 18c10.61 4.704 19.074 17.42 19.074 17.42C19.097 25.083 6.624 21.597 5.795 21.373l-.044-.012h5.083zm-.222-10.452s16.177 10.12 20.446 19.162c0 0-12.775-11.439-27.032-14.543l6.659.469zM0 .065C6.098-.368 12.461 1.51 12.461 1.51l17.623.39c.862.019 1.55.725 1.55 1.591V18C20.94 3.823 0 .065 0 .065"
          clipRule="evenodd"
        />
        <path
          fill="#F7F8F9"
          d="M52.363 27.6c1.603 0 3.905-.796 4.723-2.472l.175 2.046h3.352V13.167h-3.41l-.117 1.931c-.816-1.42-2.712-2.272-4.636-2.272-4.168 0-7.433 2.528-7.433 7.33 0 4.887 3.12 7.444 7.346 7.444m.466-3.182c-2.36 0-4.256-1.591-4.256-4.261 0-2.672 1.895-4.234 4.256-4.234 2.798 0 4.197 2.131 4.197 4.234 0 2.13-1.399 4.26-4.197 4.26m12.567-13.183c1.049 0 2.099-.682 2.099-2.017-.002-1.365-1.053-2.018-2.1-2.018-1.05 0-2.1.654-2.1 2.017 0 1.336 1.05 2.018 2.1 2.018m1.777 15.94V13.11h-3.556v14.064zm6.765 0v-7.388c0-2.586 1.72-3.552 3.584-3.552 1.167 0 1.837.312 2.566.91l1.604-3.012c-.787-.768-2.216-1.336-3.702-1.336-1.458 0-2.945.255-4.052 1.99l-.264-1.62H70.38v14.007h3.558m15.77 0 6.035-14.037H94.17L88.92 25.554l-5.247-12.416h-1.575l6.035 14.036zm14.897.198c2.303 0 4.81-.91 6.209-2.7l-1.02-.795c-1.079 1.392-3.294 2.13-5.189 2.13-2.973 0-5.568-1.902-5.86-5.199h12.973c.029-.37.058-.738.058-1.08 0-4.716-3.41-6.818-7.171-6.818-4.051 0-7.317 3.04-7.317 7.246 0 4.46 3.265 7.216 7.317 7.216m5.831-7.785H98.745c.32-3.438 2.886-5.398 5.859-5.398 3.469 0 5.801 1.932 5.83 5.398zm6.413 7.586v-7.813c0-2.927 2.098-5.115 5.13-5.115 3.061 0 5.045 1.704 5.045 4.86v8.068h1.428v-8.097c0-3.893-2.652-6.195-6.502-6.195-2.011.029-4.022.825-5.131 2.757v-2.501h-1.399v14.036zm21.748.228c2.449 0 4.809-1.194 6.005-3.324v3.096H146V7.284h-1.399v8.922c-1.167-2.274-3.498-3.296-5.977-3.296-4.023 0-7.229 2.613-7.229 7.245 0 4.66 3.177 7.245 7.2 7.245zm.087-1.364c-3.236 0-5.889-1.99-5.889-5.881 0-3.95 2.653-5.91 5.889-5.91 3.323 0 5.889 2.386 5.889 5.88 0 3.495-2.507 5.91-5.889 5.91"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h146v36H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SvgLogoBlue = ({ color = "#2F80ED", size = 16, ...rest }) => {
  return (
    <svg
      width="180"
      height="45"
      viewBox="0 0 180 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8874_10186)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7225 32.9197L12.7658 32.955C13.8549 33.8555 27.0518 44.7602 27.5053 45H15.8047C14.0891 45 12.6972 43.5698 12.7017 41.8071L12.7225 32.9197ZM13.285 22.9288C26.294 28.6967 36.6728 44.2879 36.6728 44.2879C23.4162 31.6145 8.12166 27.3401 7.10571 27.0664L7.052 27.0517H13.285V22.9288ZM13.012 10.1127C13.012 10.1127 32.8477 22.5212 38.0826 33.6083C38.0826 33.6083 22.4181 19.5828 4.93655 15.7762L13.1015 16.3515L13.012 10.1127ZM0 0.936931C7.47718 0.405749 15.2796 2.70999 15.2796 2.70999L36.8891 3.1882C37.9453 3.21175 38.7882 4.07694 38.7882 5.1393V22.9288C25.6778 5.54542 0 0.936931 0 0.936931Z"
          fill="#4834D4"
        />
        <path
          d="M64.2066 34.6992C66.1728 34.6992 68.9954 33.7236 69.9979 31.6681L70.2128 34.1768H74.3228V17.001H70.1412L69.9979 19.3699C68.9969 17.6278 66.6726 16.5831 64.314 16.5831C59.2029 16.5831 55.1987 19.6834 55.1987 25.572C55.1987 31.5636 59.0238 34.6992 64.2066 34.6992ZM64.7779 30.797C61.8837 30.797 59.5594 28.8459 59.5594 25.572C59.5594 22.2966 61.8837 20.3808 64.7779 20.3808C68.2092 20.3808 69.9248 22.994 69.9248 25.572C69.9248 28.1837 68.2092 30.797 64.7779 30.797ZM80.1873 14.632C81.4733 14.632 82.7608 13.7962 82.7608 12.16C82.7593 10.4855 81.4703 9.68506 80.1858 9.68506C78.8983 9.68506 77.6109 10.487 77.6109 12.1585C77.6109 13.7962 78.8983 14.632 80.1858 14.632H80.1873ZM82.3669 34.1768V16.9318H78.0062V34.1768H82.3669ZM90.6616 34.1768V25.1188C90.6616 21.9479 92.7696 20.7634 95.0566 20.7634C96.4873 20.7634 97.3093 21.1459 98.203 21.8787L100.169 18.1854C99.204 17.2437 97.4526 16.5478 95.6295 16.5478C93.8423 16.5478 92.0192 16.8612 90.6616 18.9874L90.3379 17.001H86.2994V34.1768H90.6601H90.6616ZM109.999 34.1768L117.399 16.9656H115.468L109.034 32.1904L102.599 16.9656H100.669L108.069 34.1768H109.999ZM128.265 34.4211C131.089 34.4211 134.163 33.3058 135.878 31.1104L134.628 30.1348C133.305 31.8417 130.588 32.7481 128.265 32.7481C124.619 32.7481 121.437 30.4144 121.081 26.3724H136.987C137.023 25.9192 137.058 25.4675 137.058 25.0481C137.058 19.2655 132.877 16.6875 128.265 16.6875C123.297 16.6875 119.293 20.4146 119.293 25.572C119.293 31.0412 123.296 34.4211 128.265 34.4211ZM135.414 24.8745H121.079C121.471 20.6589 124.618 18.2561 128.264 18.2561C132.517 18.2561 135.377 20.6251 135.413 24.8745H135.414ZM143.278 34.1768V24.5964C143.278 21.0076 145.851 18.3252 149.569 18.3252C153.323 18.3252 155.754 20.4146 155.754 24.283V34.1768H157.506V24.2477C157.506 19.4744 154.253 16.6522 149.533 16.6522C147.067 16.6875 144.601 17.6631 143.242 20.0321V16.9656H141.526V34.1768H143.278ZM169.945 34.4564C172.948 34.4564 175.842 32.9923 177.309 30.3806V34.1768H179.023V9.78806H177.307V20.7281C175.876 17.9397 173.018 16.6861 169.979 16.6861C165.046 16.6861 161.115 19.8908 161.115 25.5705C161.115 31.284 165.01 34.4535 169.943 34.4535L169.945 34.4564ZM170.052 32.7834C166.084 32.7834 162.832 30.3438 162.832 25.572C162.832 20.7295 166.084 18.3252 170.052 18.3252C174.126 18.3252 177.273 21.2519 177.273 25.5367C177.273 29.8214 174.2 32.7834 170.052 32.7834Z"
          fill="#130F40"
        />
      </g>
      <defs>
        <clipPath id="clip0_8874_10186">
          <rect
            width="179.023"
            height="44.1426"
            fill="white"
            transform="translate(0 0.857422)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SvgKeyLogo = ({ color = "#fff", size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
      viewBox="0 0 100 100"
    >
      <path fill="#EFF8FF" d="M100 0H0v100h100V0Z" />
      <path
        fill="#EFF8FF"
        d="M50.446 97.989c26.492 0 47.967-21.476 47.967-47.968 0-26.492-21.475-47.968-47.967-47.968-26.492 0-47.968 21.476-47.968 47.968 0 26.492 21.476 47.968 47.968 47.968Z"
      />
      <path
        fill="#74D2FB"
        d="M50.051 58.956c7.792 0 14.108-6.316 14.108-14.108 0-7.792-6.316-14.108-14.108-14.108-7.792 0-14.108 6.316-14.108 14.108 0 7.792 6.316 14.108 14.108 14.108Z"
      />
      <path
        fill="#0066F5"
        d="M30.977 61.298c-.349.16-.687.338-1.026.508L15.514 83.109c.884.94 1.797 1.806 2.747 2.662l16.374-24.172a3.762 3.762 0 0 0-3.658-.301Zm45.004 2.99-22.77 33.606a47.174 47.174 0 0 0 4.938-.583l20.936-30.897a50.248 50.248 0 0 0-3.104-2.125Zm4.6 3.274L60.772 96.794a47.31 47.31 0 0 0 5.643-1.646L83.43 70.026c-.893-.856-1.862-1.665-2.85-2.464Zm-9.594-5.963-24.548 36.23c1.25.093 2.502.16 3.762.16h.687l23.456-34.622a38.068 38.068 0 0 0-3.357-1.768Zm-54.137 9.48-5.117 7.525a48.716 48.716 0 0 0 2.474 3.056l12.227-17.973a48.213 48.213 0 0 0-9.584 7.392Zm48.607-8.21a18.746 18.746 0 0 1-6.584 6.583L40.23 96.962c1.345.283 2.7.537 4.073.706l24.83-36.68a3.931 3.931 0 0 0-3.677 1.88Zm-20.909 7.57L29.18 93.117a46.533 46.533 0 0 0 3.499 1.552l15.707-23.175a16.548 16.548 0 0 1-3.838-1.053Zm-8.605-7.458L19.67 86.993a38.08 38.08 0 0 0 2.991 2.295L38.35 66.132a18.491 18.491 0 0 1-2.407-3.15Zm14.728 8.672h-.122L34.504 95.336c1.232.423 2.483.818 3.762 1.147l17.352-25.62a15.99 15.99 0 0 1-4.947.79Zm34.18-.273L69.584 93.906a47.03 47.03 0 0 0 7.243-3.988L87.456 74.24a112.26 112.26 0 0 0-2.606-2.86Zm-45.1-3.96-15.5 22.912a33.985 33.985 0 0 0 3.236 1.881l15.35-22.648a16.516 16.516 0 0 1-3.085-2.144Zm49.98 9.773c-.347-.49-.724-.94-1.081-1.41l-7.176 10.58a48.447 48.447 0 0 0 8.258-9.17Z"
      />
      <path
        fill="#00419E"
        d="M11.16 77.86c.188.264.385.508.573.763l5.117-7.525a48.517 48.517 0 0 0-5.69 6.763Zm15.227-14.154L14.16 81.679c.423.49.865.94 1.307 1.43l14.484-21.331a61.37 61.37 0 0 0-3.564 1.928Zm9.556-.838a3.97 3.97 0 0 0-1.26-1.27L18.26 85.77c.47.424.94.828 1.439 1.223l16.243-24.012v-.113Zm2.436 3.264L22.69 89.288c.508.358 1.035.706 1.562 1.044l15.5-22.911a16.73 16.73 0 0 1-1.373-1.289Zm4.458 3.48L27.477 92.26c.565.301 1.13.583 1.694.856L44.539 70.44c-.583-.244-1.15-.52-1.702-.828Zm5.549 1.881L32.679 94.696c.602.235 1.204.452 1.825.668l16.045-23.683a18.115 18.115 0 0 1-2.163-.188Zm7.232-.63-17.352 25.62c.649.16 1.307.301 1.965.442l18.642-27.51a16.27 16.27 0 0 1-3.255 1.448Zm14.748-9.565a3.676 3.676 0 0 0-1.232-.32l-24.83 36.68c.705.085 1.42.142 2.135.198l24.548-36.229-.621-.33Zm3.978 2.05L50.888 97.97c.78 0 1.56 0 2.323-.075l22.77-33.605c-.536-.33-1.091-.63-1.636-.94Zm4.74 3.066L58.149 97.311a47.94 47.94 0 0 0 2.625-.517L80.58 67.562a62.719 62.719 0 0 0-1.495-1.148Zm4.365 3.612L66.435 95.148a44.76 44.76 0 0 0 3.113-1.242L84.85 71.38c-.489-.451-.94-.912-1.401-1.354Zm5.163 5.756a40.143 40.143 0 0 0-1.232-1.542L76.752 89.918a46.8 46.8 0 0 0 4.703-3.555l7.157-10.58Z"
      />
      <path
        fill="#74D2FB"
        d="M66.04 77.531h8.464v3.998a3.762 3.762 0 0 1-3.762 3.762h-.94a3.762 3.762 0 0 1-3.762-3.762V77.53Z"
      />
    </svg>
  );
};
